const rupeeFormat = (value) => {
    if (value === undefined || value === null || value === "") {
        return "";
    }else {
        return value.toLocaleString("hi-IN", { minimumFractionDigits: 0 });
    }
} 

export default rupeeFormat;